module.exports = __webpack_public_path__ + "static/media/SASS.da6a5a48.png";